import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO: relay to set the applied params to match the edited params, and to
 * reset the edited params to be empty
 */
export const applyParams = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.applyParams.relay(forwardTo =>
      rxjs
        .combineLatest({
          descending: plugin.editedParams.selectors.descending.asObservable,
          filters: plugin.editedParams.selectors.filters.asObservable,
          quantity: plugin.editedParams.selectors.quantity.asObservable,
          search: plugin.editedParams.selectors.search.asObservable,
          skip: plugin.editedParams.selectors.skip.asObservable,
          sortBy: plugin.editedParams.selectors.sortBy.asObservable,
        })
        .pipe(
          rxjs.take(1),
          rxjs.mergeMap(values => [
            // Writes edited params to applied params
            forwardTo(plugin.appliedParams.actions.writeAllProperties, {
              input: { values },
            }),
            // Clears everything from edited params
            forwardTo(plugin.editedParams.actions.writeAllProperties, {
              input: { values: {} },
            }),
          ]),
        ),
    ).asObservable,
)
